// QUÉ SE LE DICE A QUIEN ESTÁ TRABAJANDO CUANDO LA LICENCIA SE VENCE.
//
// =====================================================================
// POR QUÉ ESTO VIVE FUERA DEL COMPONENTE
// =====================================================================
// Porque es la parte que se puede equivocar en silencio. Pintar una caja
// ámbar se ve; decir «modo consulta» cuando todavía se puede registrar,
// o callarse cuando ya no, no se ve hasta que alguien pierde una hora en
// el andén. Aquí es una función pura con sus pruebas al lado.
//
// =====================================================================
// LOS TRES TONOS SON LOS DE LA CASA
// =====================================================================
//   AVISO         → ámbar   · atención, todo sigue funcionando
//   GRACIA        → ámbar   · atención, con la fecha del corte
//   SOLO_LECTURA  → rojo    · problema, ya no se registra
//   AL_CORRIENTE  → nada    · un aviso permanente que no dice nada es
//                             la forma más rápida de que se deje de leer
//
// LA FRASE LARGA LA ESCRIBE LA NUBE, no esto. `mensaje` viene de
// `estado_licencia()` y ya trae los días y la fecha concretos; repetirlo
// aquí sería tener el plazo escrito en dos sitios, y el segundo se queda
// viejo. Esto pone el título, el tono y **qué hacer ahora**, que es lo
// que el mensaje de la nube no puede saber.

/** El aviso que toca pintar, o `null` si no hay nada que decir. */
export function avisoDeLicencia(licencia) {
  if (!licencia || !licencia.mensaje) return null;
  const estado = licencia.estado || 'AL_CORRIENTE';
  if (estado === 'AL_CORRIENTE') return null;

  if (estado === 'SOLO_LECTURA') {
    return {
      tono: 'problema',
      titulo: 'TEGO está en modo consulta',
      mensaje: licencia.mensaje,
      // QUÉ HACER AHORA, que es lo que exige la Doctrina 2. Y lo
      // primero no es «paga»: es que nadie crea que perdió sus datos.
      queHacer: 'Puedes seguir consultando y exportando todo lo tuyo. '
        + 'Para volver a registrar movimientos, avisa a quien lleva la '
        + 'cuenta de TEGO en tu empresa.',
    };
  }
  return {
    tono: 'atencion',
    titulo: 'Tu suscripción de TEGO está vencida',
    mensaje: licencia.mensaje,
    queHacer: 'Hoy no te cambia nada: puedes trabajar igual. '
      + 'Avisa a quien lleva la cuenta de TEGO en tu empresa.',
  };
}

/** Una frase sobre las actualizaciones, o `null` si no hay ninguna. */
export function avisoDeActualizacion(actualizacion) {
  if (!actualizacion || !actualizacion.hay_version_nueva) return null;
  const v = actualizacion.version ? ` (${actualizacion.version})` : '';
  // AUTOMÁTICA Y MANUAL NO SE DICEN IGUAL, porque lo que tiene que hacer
  // quien lo lee es distinto: en una espera, en la otra alguien tiene
  // que ir a pulsar. Decir «hay una versión nueva» a secas deja a las
  // dos personas sin saber si les toca algo.
  return actualizacion.modo === 'AUTOMATICA'
    ? `Hay una versión nueva de TEGO${v}. Se instalará sola en la próxima `
      + 'ventana de mantenimiento; no tienes que hacer nada.'
    : `Hay una versión nueva de TEGO${v}. La instala quien administra este `
      + 'servidor, desde Ajustes → Este servidor.';
}
